import { pushDataLayerEvent } from '@/modules/services/gtm'

export default {
  data () {
    return {
      deferredPrompt: null
    }
  },

  created () {
    window.addEventListener('beforeinstallprompt', (e) => {
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e
      pushDataLayerEvent('a2hsAvailable')
    })

    window.addEventListener('appinstalled', () => {
      pushDataLayerEvent('a2hsCompleted')
    })
  },

  watch: {
    deferredPrompt (newEvent) {
      if (!newEvent) {
        return
      }

      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          pushDataLayerEvent('a2hsAccepted')
        } else {
          pushDataLayerEvent('a2hsDismissed')
        }
        this.deferredPrompt = null
      })
    }
  }
}
